import { http } from "@/core/api/";
import documentsService from "@/services/documents";

const baseApiURL = "api/stipulationcompliance";

export const getInitFilters = () => {
  return http.get(`${baseApiURL}/initfilters`);
};

export const getCenters = academicYearId => {
  return http.get("api/location/centers", {
    params: {
      academicYearId
    }
  });
};

export const getMunicipalities = (academicYearId, centerId) => {
  return http.get("api/location/municipalities", {
    params: {
      academicYearId,
      centerId
    }
  });
};

export const getSchools = (academicYearId, centerId, municipalityId) => {
  return http.get("api/location/schools", {
    params: {
      academicYearId,
      centerId,
      municipalityId
    }
  });
};

export const searchRelatedServices = (payload, pageIndex, pageSize) => {
  return http.get(`${baseApiURL}/search`, {
    params: {
      ...payload,
      pageIndex,
      pageSize
    }
  });
};

export const getManagementTypes = () => {
  return http.get("api/code/compmanagementtype");
};
export const addManagement = managementModel =>
  http.post(`${baseApiURL}/managements`, managementModel, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });

export const getManagement = (stipulationType, detailId) =>
  http.get(`${baseApiURL}/managements/${stipulationType}/${detailId}`);

export const deleteManagement = (stipulationType, id) =>
  http.delete(`${baseApiURL}/managements/${stipulationType}/${id}`);

export const accomplishCompliance = payload => {
  return http.put(`${baseApiURL}/accomplish`, payload);
};

export const excludeCompliance = payload => {
  return http.put(`${baseApiURL}/exclude`, payload);
};

export const denyCompliance = payload => {
  return http.put(`${baseApiURL}/deny`, payload);
};

export const pendingApprovalStatusCompliance = payload => {
  return http.put(`${baseApiURL}/pendingapprovalstatuscompliance`, payload);
};

export const queueComplianceManagementReport = async payload => {
  await http.get(`api/report/queuecompliancemanagementreport`, {
    params: payload
  });
};

export const downloadQueuedReport = async executionLogId => {
  await http
    .get(`api/report/downloadqueuedreport/${executionLogId}`)
    .then(({ data: response }) => {
      documentsService.Download(response);
    });
};

export const cancelQueuedReport = async executionLogId => {
  await http.get(`api/report/cancelqueuedreport/${executionLogId}`);
};

export const hasAdvancedFilter = payload => {
  return http.put(`${baseApiURL}/hasAdvancedFilter`, payload);
};
